import { createSlice, current } from '@reduxjs/toolkit'

export const orderSlice = createSlice({
  name: 'orders',
  initialState: {
    orders: [],
    showModal: false,
    sortOrderType: true,
    sortOnlyOnce: false,
  },
  reducers: {
    setOrders: (state, action) => {
      const o = action.payload.map((order) => {
        return {
          ...order,
          customerMobile: order.customer.customerMobile,
          customerName: order.customer.customerName,
          customerTel: order.customer.customerTel,
        }
      })
      state.orders = o
    },
    addOrder: (state, action) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      const o = {
        ...action.payload,
        customerMobile: action.payload.customer.customerMobile,
        customerName: action.payload.customer.customerName,
        customerTel: action.payload.customer.customerTel,
      }
      state.orders = [...state.orders, o]
    },
    removeOrder: (state, action) => {
      state.orders = state.orders.filter((item) => item.id != action.payload)
    },
    addMultipleOrder: (state, action) => {
      Object.keys(action.payload).map((item) => {
        state.orders = [...state.orders, action.payload[item]]
      })
    },
    showAddOrderModal: (state, action) => {
      state.showModal = action.payload
    },
    changeOrderState: (state, action) => {
      state.orders = state.orders.map((order) => {
        let status = order.id != action.payload.id ? order.status : action.payload.status
        let temp = order
        temp['status'] = status
        if (status == 1 && order.id == action.payload.id) {
          temp['price'] = action.payload.price
          temp['discount'] = action.payload.discount
        }
        return temp
      })
    },
    changeOrder: (state, action) => {
      state.orders = state.orders.map((order) => {
        return order.id != action.payload.id ? order : action.payload.order
      })
    },
    changeInstall: (state, action) => {
      state.orders = state.orders.map((order) => {
        if (order?.install.id != action.payload.id) return order
        return { ...order, install: { ...action.payload, status: 1 } }
      })
    },
    addInstall: (state, action) => {
      state.orders = state.orders.map((order) => {
        if (order?.id != action.payload) return order
        return { ...order, install: {} }
      })
    },
    sortOrder: (state, action) => {
      let order = state.orders
      state.sortOrderType = !state.sortOrderType
      order.sort((firstItem, secondItem) => {
        return state.sortOrderType
          ? action.payload.digits
            ? parseInt(secondItem[action.payload.column]) -
            parseInt(firstItem[action.payload.column])
            : secondItem[action.payload.column]?.localeCompare(firstItem[action.payload.column])
          : action.payload.digits
            ? parseInt(firstItem[action.payload.column]) - parseInt(secondItem[action.payload.column])
            : firstItem[action.payload.column]?.localeCompare(secondItem[action.payload.column])
      })
    },
    sortComplexOrder: (state, action) => {
      if (action.payload.sortOnlyOnce == true && state.sortOnlyOnce == true) {
        return
      }
      let order = state.orders
      const rowField = action.payload.field
      state.sortOrderType = !state.sortOrderType
      order.sort((firstItem, secondItem) => {
        let t1 =
          firstItem[rowField] &&
            firstItem[rowField].filter((l) => l.newValue == action.payload.status).length > 0
            ? firstItem[rowField].filter((l) => l.newValue == action.payload.status)[0].created_at
            : ''
        let t2 =
          secondItem[rowField] &&
            secondItem[rowField].filter((l) => l.newValue == action.payload.status).length > 0
            ? secondItem[rowField].filter((l) => l.newValue == action.payload.status)[0].created_at
            : ''
        return state.sortOrderType ? t1.localeCompare(t2) : t2.localeCompare(t1)
      })
      state.sortOnlyOnce = true
    },
    addOrderDetail: (state, action) => {
      state.orders = state.orders.map((order) => {
        if (order.id != action.payload.id) return order
        return { ...order, detail: [...order.detail, action.payload.detail] }
      })
    },
    editOrderDetail: (state, action) => {
      state.orders = state.orders.map((order) => {
        if (order.id != action.payload.id) return order
        return {
          ...order,
          detail: order.detail.map((d) => {
            if (d.id != action.payload.detail.id) return d
            return action.payload.detail
          }),
        }
      })
    },
    editOrderDiscription: (state, action) => {
      state.orders = state.orders.map((order) => {
        if (order.id != action.payload.id) return order
        return {
          ...order,
          ...action.payload,
        }
      })
    },
    deleteOrderDetail: (state, action) => {
      state.orders = state.orders.map((order) => {
        if (order.id != action.payload.id) return order
        return { ...order, detail: [...order.detail.filter((od) => od.id == action.payload.id)] }
      })
    },
  },
})

// Action creators are generated for each case reducer function
export const {
  addOrder,
  removeOrder,
  showAddOrderModal,
  changeOrderState,
  setOrders,
  addMultipleOrder,
  sortOrder,
  sortComplexOrder,
  addOrderDetail,
  editOrderDetail,
  deleteOrderDetail,
  editOrderDiscription,
  changeInstall,
  addInstall,
} = orderSlice.actions

export default orderSlice.reducer
